import { render } from "./index.vue?vue&type=template&id=1aef9104&scoped=true"
import script from "./index.js?vue&type=script&lang=js"
export * from "./index.js?vue&type=script&lang=js"

import "./index.css?vue&type=style&index=0&id=1aef9104&lang=css&scoped=true"
import "./index.vue?vue&type=style&index=1&id=1aef9104&scoped=true&lang=css"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aef9104"]])

export default __exports__